var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms__content" }, [
    _c("p", [
      _vm._v(
        "\n   " +
          _vm._s(_vm.$t("terms.text[0]", { hostname: _vm.hostname })) +
          "\n "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    " + _vm._s(_vm.$t("terms.text[1]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.text[3]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[0].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[0].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[1].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[1].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[1].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[1].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[1].text[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[1].text[4]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[2].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[2].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[2].text[1]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[3].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[3].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[3].text[1]")))]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[3].clarification[0]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[3].clarification[1]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[3].clarification[2]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[3].clarification[3]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[3].clarification[4]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[3].clarification[5]")))])
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[4].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[4].text[0]")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    " + _vm._s(_vm.$t("terms.list[4].text[1]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[4].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[4].text[3]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[5].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[5].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[6].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[6].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[7].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[7].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[7].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[7].text[2]")))]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[7].clarification[0]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[7].clarification[1]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[7].clarification[2]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[7].clarification[3]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[7].clarification[4]")))])
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[7].text[3]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[8].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[8].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[8].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[8].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[8].text[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[8].text[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[8].text[5]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[9].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[9].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[9].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[9].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[9].text[3]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[10].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[10].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[11].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[11].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[12].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[12].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[13].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[13].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[14].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[14].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[15].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[15].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[16].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[16].text")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[17].title")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v(_vm._s(_vm.$t("terms.list[17].text[0]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ]),
      _vm._v("\n    " + _vm._s(_vm.$t("terms.list[17].text[1]")))
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[17].clarification[0]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[17].clarification[1]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[17].clarification[2]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[17].clarification[3]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[17].clarification[4]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("terms.list[17].clarification[5]")))])
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[18].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[18].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[18].text[1]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("terms.list[19].title")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("terms.list[19].text[0]", { supportEmail: _vm.supportEmail })
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("terms.list[19].text[1]")))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }